// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3fRL1","title":"ClientCherryInfo_title__2eVdb","itemText":"ClientCherryInfo_itemText__1m2Tt"};